import React from "react";
import { Typography, Box, Button, Chip } from "@mui/material";
import { Accordion } from "@mui/material";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";
import FAQ from "../assets/faq.png";
import APIURLConstants from "../config/config";
import ApiHelper from "../utillity/ApiHelper";

export const Faq = () => {
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const getAllFAQ = () => {
		ApiHelper.get(APIURLConstants.GET_FAQ)
			.then((res) => {
				console.log(res.data.result.faq);

				console.log(res.data);
				setData(res.data.result.faq);

				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);

				console.log(error);
			});
	};
	React.useEffect(() => {
		getAllFAQ();
	}, []);
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: { xs: "300px", md: "1280px" },
				zIndex: 3,
				// p: "20px 20px",
				gap: { xs: 0, md: 4 },
				background: "#fff",
				justifyContent: "center",
				alignItems: "center",
				alignSelf: "center",
				alignContent: "center",
				py: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
				}}
			>
				<Chip
					label="FAQ’s"
					variant="filled"
					sx={{
						borderRadius: 4,
						fontSize: "18px",
						color: "#667085",
						width: "200px",
					}}
				/>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					width: { xs: "300px", md: "1280px" },
					justifyContent: "center",
					alignSelf: "center",
					alignItems: "center",
					alignContent: "center",
					textAlign: "center",
					gap: { xs: 0, md: 4 },
				}}
			>
				<Box
					width={{ xs: "290px", md: "500px" }}
					display={"flex"}
					flexDirection={"column"}
					gap={2}
				>
					<Typography
						fontWeight={600}
						fontSize={{ xs: 30, md: 44 }}
						color="#000000"
					>
						{"Frequently Asked Questions"}
					</Typography>

					<Box
						component="img"
						src={FAQ}
						width={{ xs: "280px", md: "491px" }}
						height={300}
					/>
				</Box>
				<Box
					width={"713"}
					display={"flex"}
					flexDirection={"column"}
					gap={"5px"}
					background="#F8FAFC"
					border={1}
					borderColor={"#EEF2F6"}
					mt={8}
				>
					{data.length > 0 ? (
						data.map((key, index) => {
							return (
								<Accordion sx={{ p: { xs: 0, md: 1 } }} key={index}>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										aria-controls={"panel" + index + "content"}
										id={"panel" + index + "header"}
										// sx={{ backgroundColor: "aliceblue" }}
									>
										<Typography
											fontSize={{ xs: 16, md: 18 }}
											fontWeight={600}
											textAlign={"left"}
										>
											{key.question}
										</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Typography
											fontSize={15}
											color={"#667085"}
											textAlign={"left"}
										>
											{key.answer}
										</Typography>
									</AccordionDetails>
								</Accordion>
							);
						})
					) : (
						<Box>
							<Typography>No FAQ Found</Typography>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};
